import { IAlertState } from "../../interface/alert-state.interface";

export const initAlertState: IAlertState = {
    alertStatus: 'noAlert',
    message: '',
    alertColor: '',
}